import { ViewColumnSystemName } from '../../../../shared/entities/view/components/view-grid/enums/ViewColumnSystemName';

export const filingsCustomScreenColumns = [
  ViewColumnSystemName.CompanyName,
  ViewColumnSystemName.Ticker,
  ViewColumnSystemName.OfferDate,
  ViewColumnSystemName.FileDate,
];
